// Account options for Receipts / Expense. Hardcoded list - no backend CRUD.
export const ACCOUNTS = [
  { value: 1, name: "Encrypted Infoweb" },
  { value: 2, name: "Encrypted Digital" },
  { value: 3, name: "Personal Saving Account" },
];

export const accountName = (value: any) =>
  ACCOUNTS.find((a) => Number(a.value) === Number(value))?.name || (value ? "Account " + value : "");
